module.exports = __webpack_public_path__ + "media/images/notice-close-8123e90e913e81e4c27e3559a8668e8d.svg";